import * as React from 'react';
import { observer } from 'mobx-react';
import BaseManagerCard from 'nomst/Components/Decision/ManagerListSidePanel/baseManagerCard';
import { NavigationStore } from 'nomst/Stores/Navigation/navigation.store';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import { WorkflowStatusListType } from 'typings/enums';
import { managerListSidePanelStore } from 'utils/MobxDataManager/singletons';

export interface IManagerCardWorkflowStatusProps {
    navigationStore: Nullable<NavigationStore>;
    configuration: Configuration;
    managerCardWorkflowStatus: IManagerCard;
    isManagerSelected: boolean;
    workflowStatusType: WorkflowStatusListType;
    currentReviewer: string;
}

export class ManagerCardWorkflowStatus extends React.Component<IManagerCardWorkflowStatusProps> {
    constructor(props: IManagerCardWorkflowStatusProps) {
        super(props);

        this.handleStatusCardClick = this.handleStatusCardClick.bind(this);
        this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    }

    render(): React.ReactNode {
        const { managerCardWorkflowStatus, isManagerSelected, currentReviewer } = this.props;
        return (
            <BaseManagerCard
                onCardClick={this.handleStatusCardClick}
                onCheckboxClick={this.handleCheckboxClick}
                isManagerSelected={isManagerSelected}
                currentReviewer={currentReviewer}
            >
                <h3 className="nomst-manager-list-card__name">{managerCardWorkflowStatus.displayName}</h3>
                <h4 className="nomst-manager-list-card__title">{managerCardWorkflowStatus.jobTitleInternal}</h4>
            </BaseManagerCard>
        );
    }

    private handleStatusCardClick(): void {
        const { navigationStore, managerCardWorkflowStatus, workflowStatusType } = this.props;
        const { cycleId } = this.props.configuration;
        navigationStore?.navigateToWorkflowStatusManagersRoute(
            cycleId,
            [managerCardWorkflowStatus.managerSourceId],
            workflowStatusType);
    }

    private handleCheckboxClick(): void {
        const {
            navigationStore,
            managerCardWorkflowStatus,
            configuration,
            workflowStatusType } = this.props;
        managerListSidePanelStore.toggleManagerSelection(managerCardWorkflowStatus.managerSourceId);
        navigationStore?.navigateToWorkflowStatusManagersRoute(
            configuration.cycleId,
            managerListSidePanelStore.selectedManagerIds,
            workflowStatusType);
    }
}

export default observer(ManagerCardWorkflowStatus);